export default function() {
    this.loadSettings()
    this.preventIncompleteUserAccess()
    this.updateImpersonatedUser()
}
